import React from 'react'
import { t } from '@lingui/macro'

import GeneralRemoveModal from '../../../components/common/general-remove-modal/GeneralRemoveModal'
import pathwayRemoveGroup from '../../../operations/pathwayRemoveGroup'

interface IProps {
  groupId: number | null
  pathwayId: number
  show: boolean
  onCanceled: () => void
  onDeleted: () => void
}

export default (props: IProps) => {
  const { pathwayId, groupId } = props

  return (
    <GeneralRemoveModal
      entityName="pathway group"
      confirmButton={t`Remove`}
      header={t`Remove group`}
      operation={async () => {
        if (groupId) {
          return pathwayRemoveGroup(pathwayId, groupId)
        }
      }}
      {...props}
    />
  )
}
